import React, { useContext } from 'react';

import { Context } from '@store/store';

import { StyledShowTOCSidebarButton } from './show-toc-sidebar-button.styles';

const ShowTOCSidebarButton = () => {
  const [state, dispatch] = useContext(Context);
  const handleClick = () => {
    dispatch({ type: 'TOGGLE_TOC_SIDEBAR' });
  };
  return (
    <StyledShowTOCSidebarButton
      onClick={handleClick}
      data-ignore-click-outside="sidebar"
      isActive={state.isTOCSidebarOpened}
    >
      Оглавление
    </StyledShowTOCSidebarButton>
  );
};

export default ShowTOCSidebarButton;
